// Production-safe logger that only outputs in development mode
const isDev = process.env.NODE_ENV === 'development';

const logger = {
  log: (...args: any[]) => {
    if (isDev) console.log(...args);
  },
  warn: (...args: any[]) => {
    if (isDev) console.warn(...args);
  },
  error: (...args: any[]) => {
    // Always log errors, even in production
    console.error(...args);
  },
  info: (...args: any[]) => {
    if (isDev) console.log(...args);
  },
};

export default logger;
